import { SiteCabinetVeterinaire } from "../SiteCabinetVeterinaire";


export class DataModelAddTournee {
    tourneeId: number = 0;
    date: Date = new Date();
    nom: string = "";
    siteCabinetVeterinairesid: number[] = new Array();
}